import React from 'react';
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button';
import { useEffect } from 'react'

function Links() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>

      <div
        className='text-center mx-auto my-24 md:my-36 max-w-6xl px-8'> {/* Add mx-auto to center the div */}
        {/* <h1 className="text-2xl font-bold mb-6 font-custom">Home of data couture</h1> */}
        <p className="text-3xl font-gotham text-black mb-8 max-w-prose mx-auto px-12 md:px-0">
          Links
        </p>



        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-x-2 gap-y-2">
  {/* Rapport: internal link */}
  <Link
    to="/nl/onderzoek"
    className="hover:bg-white/60 bg-white p-2 rounded-3xl flex justify-center items-center aspect-square"
  >
    <div className="p-6">
      <p className="text-2xl font-gotham text-black">
        Rapportage kwalitatief evaluatieonderzoek ‘Ik ben Jo!’
      </p>
      <p className="text-xs font-gotham text-black mt-6">
      Van Gogh Museum & Romy Raaben
      </p>
    </div>
  </Link>
          {/* Enquete: direct download */}
          <a
    href="/assets/downloads/Ik_ben_Jo_enquete.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:bg-white/60 bg-white p-2 rounded-3xl flex justify-center items-center aspect-square"
  >
    <div className="p-6">
      <p className="text-2xl font-gotham text-black">
        Deelnemersenquête zomer 2025 (download)
      </p>
      <p className="text-xs font-gotham text-black mt-6">
        Romy Raaben & Marieke Boon
      </p>
    </div>
  </a>

        </div>


      </div>

    </>
  );
}

export default Links;